import React from 'react'

const ON24 = () => {
  return (
    <div>
      <p>ON24 customer? Deploy Drift on your ON24 Engagement Hub and Target pages to start personalized conversations like you would on your website.
      Now, you can pair the right content experience with the right conversation.</p>
      <h3>Adding Drift to an ON24 Target Page</h3>
      <p>To take advantage of this new functionality, navigate to the Attributes tab and enter your Drift widget ID into the designated field.
      For Engagement Hub, you’ll need to do this only once. For Target, after you enter the Drift widget ID for your initial page, the Drift widget ID will be available for all subsequent Target pages.</p>
      <p>
        <span>Need some help? </span>
        <a href="//gethelp.drift.com/hc/en-us/articles/360051178713-How-to-Add-Drift-to-your-ON24-Audience-Console-Engagement-Hub-and-Target-Pages" target="_blank">Learn more here!</a>
      </p>
    </div>
  )
}

export default ON24


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/ON24.js